import { useQuery } from "@tanstack/react-query";
import { useShop } from "src/hooks/Utils/Shop/useShop";
import { OpenapiSingleton } from "src/utils/OpenapiSingleton";

export default function useUniverseQuery() {
  const { shopMarketId, shopLang } = useShop();
  const getUniverse = async () => {

    return await OpenapiSingleton.SearchUniverseAPIApi.listUniverses(
      shopMarketId,
      undefined,
      undefined,
      undefined,
      shopLang,
    );
  };
  return useQuery({
    queryKey: ["getUniverse"],
    queryFn: getUniverse,
    staleTime: 3600000,
  });
}
